import type { NavigationItem, NavigationItemExternalLink, NavigationItemLink } from '@/types/aggregation/common';
import { ROUTES } from '@/utils/constants';
import { NAVIGATION_ITEM_TYPE_LIVESTREAM } from '@/utils/constants/navigation';
import { removeProductFromUid } from '@/utils/url/url';

export const getPathFromLink = (link: NavigationItemLink) => {
    switch (link.type) {
        case 'static_page':
            return `${ROUTES.STATIC_PAGE}${removeProductFromUid(link.uid)}`;
        case 'category':
            return `${ROUTES.CATEGORY}${removeProductFromUid(link.uid)}`;
        case 'homepage':
            return ROUTES.HOMEPAGE;
        case 'game':
        case 'game_lobby':
            return `${ROUTES.GAME}${link.uid}`;
        case 'dynamic_route':
            return `${ROUTES.DYNAMIC_PAGE}${removeProductFromUid(link.uid)}`;
        default:
            return null;
    }
};

export const getPathFromExternalLink = (externalLink: NavigationItemExternalLink | undefined) => {
    if (!externalLink) {
        return null;
    }
    switch (externalLink.link_type) {
        case 'Document':
            return getPathFromLink(externalLink);
        case 'Web':
        case 'Media':
            return externalLink.url;
        default:
            return null;
    }
};

export const getPathFromNavigationItem = (item: NavigationItem) => {
    if (item.item_type?.toLowerCase() === NAVIGATION_ITEM_TYPE_LIVESTREAM) {
        return ROUTES.LIVESTREAM;
    }

    return getPathFromLink(item.link) || getPathFromExternalLink(item.external_link);
};
